module.exports = {
  "name": "cigre",
  "client": "pro4events",
  "description": "App for CIGRE event",
  "validLangs": ["en"],
  "native": {
    "author": "Mobile-Spot",
    "backgroundColor": "0xffffff",
    "iosBuildTarget": "12.0",
    "androidFadeSplashScreenDuration": 750,
    "androidTargetSdkVersion": 33,
    "androidCompileSdkVersion": 33,
    "androidSigning": {
      "keyAlias": "cigre",
      "keyStorePassword": "ahsahzaiye1Nooxo"
    },
    "app": "app-react",
    "name": {
      "default": "CIGRE 2024_D"
    },
    "id": "com.mobilespot.cigre.dev",
    "appleTeamId": "2BAP3P29V2",
    "playStoreUrl": ""
  },
  "undeliveredFolders": ["source", "exports"],
  "crypto": false,
  "web": {
    "url": "cigre2024.ms-dev.mobile-spot.com"
  },
  "version": {
    "mainVersion": "5.0.0",
    "buildVersion": {
      "iOS": "41",
      "android": "40",
      "web": "72"
    }
  },
  "relatedRepos": [{
    "src": "git@bitbucket.org:mobilespotdev/cordova.git",
    "branch": "inte/cigre/main",
    "postCommands": ["cd cordova && npm install"]
  }, {
    "src": "git@bitbucket.org:mobilespotdev/mobigeo.git",
    "branch": "inte/cigre/main",
    "postCommands": ["cd mobigeo && npm install"]
  }, {
    "src": "git@bitbucket.org:mobilespotdev/mobigeo-customs-master.git",
    "branch": "inte/cigre/main",
    "dest": "mobigeo/mobigeo-customs"
  }, {
    "src": "git@bitbucket.org:mobilespotdev/app-react.git",
    "branch": "inte/cigre/main"
  }, {
    "src": "git@bitbucket.org:mobilespotdev/data-master.git",
    "branch": "inte/cigre/main",
    "dest": "app-react/app-customs",
    "postCommands": ["cd app-react && yarn", "cd app-react && npm run set-env dev", "cd app-react && npm run download-assets", "cd app-react && npm run download-data-files", "cd app-react && npm run update-mobigeo"]
  }]
};